import apiService from "./ApiService";

export class BillingService {
  async save(data) {
    const response = await apiService.post("/api/billing", data);
    return response.data;
  }
  async findAll() {
    return (await apiService.get("/api/billing", {})).data;
  }
  async filteredData(data) {
    const response = await apiService.post("/api/billing/filteredData", data);
    return response.data;
  }
    async delete(id: string): Promise<void> {
    await apiService.put(`/api/billing/delete/${id}`);
  }
}

const billingService = new BillingService();
export { billingService as default };
